export default __webpack_public_path__ + "static/media/cross-red.bfaa8e3c.svg";